import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'lex-doughnut-skeleton-loader',
    templateUrl: './doughnut-skeleton-loader.component.html',
    styleUrl: './doughnut-skeleton-loader.component.scss',
    standalone: false
})
export class DoughnutSkeletonLoaderComponent implements OnInit  {
  @Input() legendItemCount: number = 6;

  private minInput = 1;
  private maxInput = 6;

  public legendCountArray: number[];

  ngOnInit(): void  {
    if(!this.isWithinMinMaxValuesRange(this.legendItemCount, this.minInput, this.maxInput)) {
      this.legendItemCount = 6;
    }

    this.legendCountArray = Array(this.legendItemCount).fill(0).map((x,i)=>i);
  }

  private isWithinMinMaxValuesRange(inputValue: number, minInput: number, maxInput: number) : boolean {
    if (inputValue < minInput || inputValue > maxInput) {
      return false;
    }
    return true;
  }
}
